import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroSection = () => {
  return (
    <section className="bg-primary text-primary-foreground overflow-hidden">
      <div className="container py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="hero-in hero-in-left">
            <div
              className="hero-in hero-in-up inline-flex items-center gap-2 bg-black/15 backdrop-blur-sm border border-primary-foreground/30 rounded-full px-4 py-1.5 mb-4"
              style={{ animationDelay: "0.1s" }}
            >
              <Sparkles className="h-4 w-4 text-primary-foreground" />
              <span className="text-primary-foreground font-bold text-sm uppercase tracking-wide">Free 15-Minute Diagnostic</span>
            </div>
            <p className="text-primary-foreground font-semibold text-sm uppercase tracking-widest mb-4">
              Tech Support Heroes
            </p>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-primary-foreground mb-6">
              Ready To Get Help?
            </h1>
            <p className="text-lg text-primary-foreground max-w-lg mb-8 leading-relaxed">
              Doing right for over 24 years. At Computer Zone in Marietta, we go above and beyond to solve your tech issues — repairs, upgrades, and remote support.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#booking">
                <Button size="lg" className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-bold text-base px-8">
                  Book Repair
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </a>
              <a href="#services">
                <Button size="lg" variant="outline" className="font-semibold text-base px-8 border-foreground/30 text-foreground hover:bg-foreground/10">
                  Our Services
                </Button>
              </a>
            </div>
          </div>

          <div className="hero-in hero-in-scale relative" style={{ animationDelay: "0.15s" }}>
            <div className="rounded-2xl overflow-hidden" style={{ boxShadow: "var(--shadow-hero)" }}>
              <picture>
                <source
                  type="image/avif"
                  srcSet="/hero-repair-640.avif 640w, /hero-repair-960.avif 960w, /hero-repair-1280.avif 1280w"
                  sizes="(min-width: 1024px) 50vw, 100vw"
                />
                <img
                  src="/hero-repair-960.webp"
                  srcSet="/hero-repair-640.webp 640w, /hero-repair-960.webp 960w, /hero-repair-1280.webp 1280w"
                  sizes="(min-width: 1024px) 50vw, 100vw"
                  alt="Expert computer repair technician working on motherboard"
                  width={960}
                  height={720}
                  fetchPriority="high"
                  decoding="async"
                  className="w-full h-[400px] lg:h-[480px] object-cover"
                />
              </picture>
            </div>
            <div className="absolute -bottom-4 -left-4 bg-card rounded-xl p-4 shadow-lg border">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-success/10 flex items-center justify-center">
                  <span className="text-success font-bold text-lg">✓</span>
                </div>
                <div>
                  <p className="font-display font-bold text-sm text-foreground">24+ Years</p>
                  <p className="text-xs text-muted-foreground">Trusted Service</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="bg-primary py-4 overflow-hidden">
        <div className="marquee-track">
          {Array.from({ length: 24 }).map((_, i) => (
            <span key={i} className="text-primary-foreground font-display font-bold text-lg whitespace-nowrap mx-8" aria-hidden={i >= 12}>
              Tech Support Heroes •
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
